import { useT } from "@reciperoll/core";

// Shown when an import overlaps items already on the shopping list, so the user
// decides rather than us guessing. "Add new" adds only what's missing; "Re-add
// all" reactivates ticked items + refreshes, no duplicates.
export function ShoppingImportChoiceModal({
  total,
  newCount,
  checkedCount,
  onAddNew,
  onReAddAll,
  onCancel,
}: {
  total: number;
  newCount: number;
  checkedCount: number;
  onAddNew: () => void;
  onReAddAll: () => void;
  onCancel: () => void;
}) {
  const t = useT();
  const presentCount = total - newCount;
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm rounded-2xl bg-surface p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-bold text-ink">{t("shopping.alreadyOnList")}</h2>
        <p className="mt-2 text-sm text-ink-soft">
          {t("shopping.overlapMessage", {
            count: presentCount,
            total,
            ticked: checkedCount ? t("shopping.overlapTickedSuffix", { count: checkedCount }) : "",
          })}
        </p>

        <div className="mt-5 flex flex-col gap-2">
          {newCount > 0 && (
            <button
              type="button"
              onClick={onAddNew}
              className="w-full rounded-xl bg-terracotta hover:bg-terracotta-dark transition-colors py-2.5 text-sm font-bold text-white cursor-pointer"
            >
              {t("shopping.addNewCount", { count: newCount })}
            </button>
          )}
          <button
            type="button"
            onClick={onReAddAll}
            className={`w-full rounded-xl py-2.5 text-sm cursor-pointer transition-colors ${
              newCount > 0
                ? "border border-line font-semibold text-ink hover:bg-surface-2"
                : "bg-terracotta hover:bg-terracotta-dark font-bold text-white"
            }`}
          >
            {t("shopping.reAddAll")}{checkedCount ? t("shopping.reAddAllHint") : ""}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full rounded-xl py-2.5 text-sm font-semibold text-ink-soft hover:bg-surface-2 cursor-pointer"
          >
            {t("common.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
